import {defineStore} from "pinia";
import {Storage} from "@ionic/storage";
import IReportDraft from "@/types/Models/Modules/Aufgabenplanung/IReportDraft";

const REPORT_DRAFT_KEY = "report-draft";

/**
 * Lokaler Zwischenspeicher (IndexedDB via Ionic Storage) für einen in Bearbeitung
 * befindlichen Rapport, unabhängig vom Server-Cache. Schützt vor Datenverlust bei
 * versehentlichem Neuladen/Schliessen der Rapport-Erstellungsseite.
 */
export const useReportCacheStore = defineStore({
    id: "reportCacheStore",
    state: () => ({
        reportDraft: null as IReportDraft | null,
        storage: new Storage({storeName: "reportCacheStore"}),
        isReady: false,
    }),
    actions: {
        async init() {
            if (this.isReady) return;
            await this.storage.create();
            const draft = await this.storage.get(REPORT_DRAFT_KEY);
            this.reportDraft = draft ?? null;
            this.isReady = true;
        },
        async setReportDraft(draft: IReportDraft) {
            this.reportDraft = draft;
            await this.storage.set(REPORT_DRAFT_KEY, draft);
        },
        async clearReportDraft(): Promise<void> {
            this.reportDraft = null;
            await this.storage.remove(REPORT_DRAFT_KEY);
        },
    },
});
